import { useEffect, useState } from "react";
import { fetchData } from "../../utils/apiUtils";
import { ActionButton } from "../../helper/ImageFormat";
import CustomPagination from "../../helper/Pagination";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import PerPageSelect from "../../Components/PerPageSelect";
import dateformate from "../../helper/DateFormate";

const EmailTemplate = () => {
 const navigator = useNavigate();
 const [loading, setLoading] = useState(false);
 const [testimonialsData, settestimonialsData] = useState([]);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);

 useEffect(() => {
  fetchEmailData();
 }, [perPage]);

 const handleEditClick = (item) => {
  navigator("/add-email-template", {
   state: item,
  });
 };

 const totalPages = Math.ceil(totalCount / perPage);

 const fetchEmailData = async (page = 1) => {
  const requestData = { perPage: perPage, pageNo: page };
  setLoading(true);
  await fetchData(
   "emailtemplate-pagination",
   requestData,
   settestimonialsData,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
 };

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchEmailData(page);
  }
 };

 const Tableheader = ["Tempalate Name", "Subject", "Updated At","Action"];
 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Email Template", path: "#" },
 ];
 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Email Template</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage}/>
    </div>

    <div className="row" style={{ marginTop: "10px" }}>
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <div className="table-responsive rounded p-1">
         <table
          className="custom-table table table-striped"
          id="testimonialtable"
         >
          <thead>
           <tr>
            {Tableheader &&
             Tableheader.length > 0 &&
             Tableheader.map((item, index) => (
              <th className="font-weight-bold " key={index}>
               {item}
              </th>
             ))}
           </tr>
          </thead>

          <tbody>
           {loading ? (
            <tr>
             <td colSpan="7" className="text-center">
              <Spinner />
             </td>
            </tr>
           ) : testimonialsData && testimonialsData?.length > 0 ? (
            testimonialsData.map((item, id) => {
             return (
              <tr key={id}>
               <td>{item?.name}</td>
               <td>{item?.subject}</td>
               <td>{dateformate(item?.updatedAt)}</td>
               <td>
                <ActionButton data={item} handleEditClick={handleEditClick} module={"Email Template"}/>
               </td>
              </tr>
             );
            })
           ) : (
            <tr>
             <td colSpan="4" className="text-center">
              <h4> No data available</h4>
             </td>
            </tr>
           )}
          </tbody>
         </table>
        </div>

        {testimonialsData?.length > 0 && (
         <div>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>
  </>
 );
};

export default EmailTemplate;
